import React, { useState } from 'react';
import { FaInfoCircle, FaListAlt } from 'react-icons/fa';
import LoanInfo from './info';
import Transactions from './transaction';

export interface Transaction {
    id: string;
    date: string;
    amount: number;
    type: 'Payment' | 'Charge';
    description: string;
}

const LoanDetails: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'details' | 'transactions'>('details');

    return (
        <div className="max-w-4xl p-5">
            <div className="mb-8">
                <h1 className="text-2xl font-bold text-gray-800 mb-8">Loan Details</h1>
                <div className="border-b border-gray-200">
                    <nav className="flex space-x-8">
                        <button
                            onClick={() => setActiveTab('details')}
                            className={`flex items-center pb-4 px-1 border-b-2 font-medium ${activeTab === 'details'
                                    ? 'border-primary-500 text-primary-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            <FaInfoCircle className="mr-2" />
                            Loan Information
                        </button>
                        <button
                            onClick={() => setActiveTab('transactions')}
                            className={`flex items-center pb-4 px-1 border-b-2 font-medium ${activeTab === 'transactions'
                                    ? 'border-primary-500 text-primary-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            <FaListAlt className="mr-2" />
                            Transactions
                        </button>
                    </nav>
                </div>
            </div>

            <div className="min-h-[400px]">
                {activeTab === 'details' ? (
                    <LoanInfo />
                ) : (
                    <Transactions />
                )}
            </div>
        </div>
    );
};

export default LoanDetails;